import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "container", "className"];
import { jsx, jsxs } from 'react/jsx-runtime';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import { forwardRef, useCallback } from 'react';
import { useFullScreenDropdownMenu } from '../menu-utils/responsiveness/FullScreenDropdownMenuContext.js';
import { sortMenuChildren } from './dropdown-menu-content.js';
import styles from './dropdown-menu.module.js';
/**
 * Based on Radix-UI Sub Content
 * @see https://www.radix-ui.com/docs/primitives/components/dropdown-menu#subcontent
 */

var DropdownMenuSubMenuContent = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      container = props.container,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _useFullScreenDropdow = useFullScreenDropdownMenu(),
      isMenuFullScreenEnabled = _useFullScreenDropdow.isMenuFullScreenEnabled;

  var preventDefault = useCallback(function (event) {
    return event.preventDefault();
  }, []);

  if (isMenuFullScreenEnabled) {
    var _sortMenuChildren = sortMenuChildren(children),
        Header = _sortMenuChildren.Header,
        OtherChildren = _sortMenuChildren.OtherChildren;

    return jsx(DropdownMenuPrimitive.Portal, {
      container: container,
      children: jsxs(DropdownMenuPrimitive.SubContent, _objectSpread(_objectSpread({}, rest), {}, {
        ref: forwardedRef,
        className: clsx(styles.content, className),
        "data-menu-fullscreen": true,
        // Prevents submenu from closing, when detects focus outside submenu in fullscreen mode,
        // while mouse is moving over submenu.
        onFocusOutside: preventDefault,
        children: [Header, jsx("div", {
          className: styles.fullScreenContent,
          children: OtherChildren
        })]
      }))
    });
  }

  return (// TODO(DSYS-440): Unify all Portals (Tooltip, Select, DropdownMenu, etc...), Expose a Provider which would tell where to mount (body? other elem?)
    jsx(DropdownMenuPrimitive.Portal, {
      container: container,
      children: jsx(DropdownMenuPrimitive.SubContent, _objectSpread(_objectSpread({}, rest), {}, {
        ref: forwardedRef,
        className: clsx(styles.content, className),
        sideOffset: 12,
        children: children
      }))
    })
  );
});
DropdownMenuSubMenuContent.displayName = 'DropdownMenuSubMenuContent';
export { DropdownMenuSubMenuContent };